var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "submenus"
  }, [_c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.orders
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.orders ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Orders")])])]), _vm.$whitelabel.isAllowedToAccessPurchaseOrder && _vm.canAccessSourcing ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.sourcing
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.sourcing ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Sourcing")])])]) : _vm._e(), _vm.canManageCreditNote ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.creditNote
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.creditNote ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Credit Notes")])])]) : _vm._e(), _vm.canManageFactoringProviders ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.factoringProviders
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.factoringProviders ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Financing")])])]) : _vm._e(), _vm.canManageDeliveries && false ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.inboundDeliveries
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.inboundDeliveries ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Dispatchs")])])]) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };